import { defineNuxtPlugin } from '#app';
import { useConsentState } from '#bubba/shared/composables/consent/useConsentState';
import type { Jurisdiction } from '#bubba/shared/composables/consent/useConsentState';

/**
 * Jurisdiction detection plugin (client-side only).
 *
 * Reads the `bubba_jurisdiction` cookie set by the geo server middleware
 * and updates the consent state's jurisdiction. This adjusts consent
 * defaults for non-GDPR regions (e.g., CCPA opt-out defaults for US visitors).
 */
export default defineNuxtPlugin(() => {
  if (typeof document === 'undefined') return;

  const cookies = document.cookie.split(';');
  let jurisdiction: Jurisdiction | null = null;

  for (const cookie of cookies) {
    const [name, ...valueParts] = cookie.trim().split('=');
    if (name === 'bubba_jurisdiction') {
      const val = valueParts.join('=');
      if (val === 'gdpr' || val === 'ccpa' || val === 'other') {
        jurisdiction = val;
      }
      break;
    }
  }

  if (jurisdiction) {
    const { setJurisdiction } = useConsentState();
    setJurisdiction(jurisdiction);
  }
});
